import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { Observable } from 'rxjs';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';

@Injectable({
  providedIn: 'root'
})
export class AutocompleteService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Search for an entity based on a search term
   * @param entity
   * @param params
   */
  public autocompleteEntity<T>(entity: string, params: any): Observable<PaginatedList<T>> {
    return this.getData(`/api/rms/autocomplete/${entity}`, params);
  }

}
